import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const orderBy = (source, keySelector, comparer) => {
    return OrderedParallelEnumerable.generate(source, keySelector, true, comparer);
};
